const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.reelitpro.app&pcampaignid=web_share";
const REELITPRO_ANDROID_APP_REFERRER = "android-app://com.reelitpro.app";

function isAppDisplayMode() {
  if (typeof window === "undefined") {
    return false;
  }

  const displayModes = ["standalone", "fullscreen", "minimal-ui"];
  const isStandaloneDisplay = displayModes.some((mode) =>
    window.matchMedia?.(`(display-mode: ${mode})`)?.matches
  );
  const isIosStandalone =
    typeof window.navigator !== "undefined" &&
    window.navigator.standalone === true;
  const isAndroidAppReferrer =
    typeof document !== "undefined" &&
    String(document.referrer || "").startsWith(REELITPRO_ANDROID_APP_REFERRER);

  return isStandaloneDisplay || isIosStandalone || isAndroidAppReferrer;
}

function isAndroidMobileBrowser() {
  if (typeof navigator === "undefined") {
    return false;
  }

  const userAgent = String(navigator.userAgent || "");
  const isAndroidUserAgent = /android/i.test(userAgent);
  const isDesktopClassUserAgent =
    /(windows nt|macintosh|mac os x|cros)/i.test(userAgent) ||
    navigator.userAgentData?.mobile === false;

  return isAndroidUserAgent && !isDesktopClassUserAgent;
}

export default function useAndroidInstallPrompt() {
  const visible = isAndroidMobileBrowser() && !isAppDisplayMode();

  const triggerPrompt = async () => {
    if (!visible || typeof window === "undefined") return;

    window.location.assign(PLAY_STORE_URL);
  };

  return { visible, triggerPrompt };
}
